// All UI strings in 8 languages. Dynamic content (team/league names from ESPN) stays as-is.
export const LANGUAGES = [
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ar", label: "العربية", flag: "🇸🇦", rtl: true },
];

export const TRANSLATIONS = {
  nl: {
    "nav.home": "Home",
    "nav.matches": "Wedstrijden",
    "nav.predictions": "Voorspellingen",
    "nav.standings": "Standen",
    "nav.live_now": "Live Now",
    "hero.badge": "AI-Aangedreven Voorspellingen",
    "hero.title_1": "Élke trap.",
    "hero.title_2": "Élke wedstrijd.",
    "hero.title_3": "Realtime.",
    "hero.description": "Live uitslagen, standen en tactische AI-voorspellingen voor de FIFA World Cup 2026, Champions League, Premier League, La Liga en Eredivisie — alles op één plek.",
    "hero.cta_matches": "Bekijk wedstrijden",
    "hero.cta_predictions": "AI Voorspellingen",
    "hero.stat_live": "Live nu",
    "hero.stat_upcoming": "Aankomend",
    "hero.stat_leagues": "Competities",
    "hero.stat_predictions": "Voorspellingen",
    "section.live_now": "Live Nu",
    "section.live_subtitle": "{n} wedstrijden actief",
    "section.upcoming": "Aankomende Wedstrijden",
    "section.upcoming_subtitle": "De volgende grote duels",
    "section.view_all": "Alles bekijken",
    "section.results": "Recente Uitslagen",
    "section.results_subtitle": "Afgelopen 24 uur",
    "section.topscorers": "Topscorers",
    "section.stand_suffix": "Stand",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Alle standen",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Club",
    "table.played": "G",
    "table.won": "W",
    "table.drawn": "G",
    "table.lost": "V",
    "table.gf": "DV",
    "table.ga": "DT",
    "table.points": "Pt",
    "table.form": "Vorm",
    "standings.title": "Standen",
    "standings.subtitle": "Live competitie ranglijsten",
    "standings.cl_spot": "CL Plek",
    "standings.eur_spot": "Europese Plek",
    "matches.title": "Wedstrijden",
    "matches.subtitle": "Filter op competitie en status",
    "filter.all": "Alle",
    "filter.live": "Live",
    "filter.upcoming": "Aankomend",
    "filter.finished": "Afgelopen",
    "matches.loading": "Laden...",
    "matches.empty": "Geen wedstrijden gevonden",
    "detail.back": "Terug",
    "detail.ai_prediction": "AI Voorspelling",
    "detail.powered_by": "Aangedreven door Claude Sonnet 4.6",
    "detail.generate_cta": "Genereer voorspelling",
    "detail.generate_help": "Genereer een AI-analyse op basis van vorm, stand en historische data.",
    "detail.thinking": "AI denkt na...",
    "detail.regenerate": "Opnieuw genereren",
    "detail.home_wins": "{team} wint",
    "detail.draw": "Gelijkspel",
    "detail.away_wins": "{team} wint",
    "detail.predicted_score": "Voorspelde score",
    "detail.confidence": "Vertrouwen",
    "detail.analysis": "Analyse",
    "detail.key_factors": "Belangrijkste factoren",
    "detail.full_time": "Full Time",
    "detail.stadium": "Stadium",
    "detail.competition": "Competitie",
    "detail.success": "AI-voorspelling gegenereerd",
    "detail.error": "Kon voorspelling niet genereren",
    "detail.loading": "Laden...",
    "pred.title": "AI Voorspellingen",
    "pred.subtitle": "Tactische analyses gegenereerd door Claude Sonnet 4.6, gebaseerd op vorm, stand en data.",
    "pred.no_matches": "Geen aankomende wedstrijden",
    "pred.predicted": "Voorspeld",
    "pred.home": "Thuis",
    "pred.draw": "Gelijk",
    "pred.away": "Uit",
    "pred.full_analysis": "Volledige analyse",
    "pred.generate": "Genereer AI",
    "pred.generating": "AI denkt...",
    "pred.success": "Voorspelling klaar",
    "pred.error": "Voorspelling mislukt",
    "footer.tagline": "Live wedstrijden, uitslagen, standen en AI-gestuurde voorspellingen voor de grootste competities ter wereld.",
    "footer.leagues": "Competities",
    "footer.data": "Data",
    "footer.data_1": "Live via ESPN publieke API",
    "footer.data_2": "AI voorspellingen (Claude)",
    "footer.data_3": "Realtime ticker",
    "footer.copyright": "Gemaakt voor voetbalfans",
    "footer.privacy": "Privacybeleid",
    "lang.label": "Taal",
    "cookie.message": "Wij gebruiken cookies voor advertenties (Google AdSense) en anonieme analytics.",
    "cookie.learn_more": "Meer weten",
    "cookie.accept": "Accepteer alles",
    "cookie.reject": "Alleen essentieel",
    "privacy.title": "Privacybeleid",
    "privacy.last_updated": "Laatst bijgewerkt",
    "privacy.s1.title": "Wie wij zijn",
    "privacy.s1.body": "{site} is een voetbalvoorspellings- en livescore-platform. Wij verzamelen minimale persoonlijke gegevens.",
    "privacy.s2.title": "Welke gegevens we verzamelen",
    "privacy.s2.body": "We verwerken de volgende gegevens:",
    "privacy.s2.item1": "Anonieme bezoekstatistieken (PostHog)",
    "privacy.s2.item2": "Cookies voor advertentie-personalisatie (Google AdSense)",
    "privacy.s2.item3": "Taalvoorkeur opgeslagen in localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Deze site gebruikt Google AdSense om advertenties weer te geven. Google kan cookies gebruiken om advertenties te personaliseren. Je kunt advertentie-personalisatie uitschakelen via:",
    "privacy.s4.title": "Externe diensten",
    "privacy.s4.body": "We maken gebruik van de volgende derde partijen:",
    "privacy.s5.title": "Jouw rechten (GDPR)",
    "privacy.s5.body": "Je hebt het recht op inzage, correctie, verwijdering en bezwaar tegen de verwerking van je gegevens.",
    "privacy.s6.title": "Contact",
    "privacy.s6.body": "Vragen over privacy? Neem contact op via:",
    "search.open": "Zoeken",
    "search.placeholder": "Zoek wedstrijd, team, competitie...",
    "search.empty": "Geen resultaten",
    "search.loading": "Zoeken...",
    "search.hint": "Tik om wedstrijd te openen",
    "matches.search_placeholder": "Filter op team, competitie of stadion",
    "search.clear": "Wissen",
    "nav.teams": "Clubs",
    "teams.title": "Clubs",
    "teams.subtitle": "{n} clubs gevonden",
    "teams.search_placeholder": "Zoek club, competitie of land...",
    "teams.empty": "Geen clubs gevonden",
    "leagues.group_international": "Internationaal",
    "leagues.group_uefa_cups": "UEFA Bekers",
    "leagues.group_top5": "Top 5 Europa",
    "leagues.group_europe_other": "Europa Overig",
    "leagues.group_cups": "Nationale Bekers",
    "leagues.group_americas": "Amerika",
    "leagues.group_asia": "Azië & Oceanië",
    "stats.title": "Wedstrijd Statistieken",
    "stats.loading": "Statistieken laden...",
    "stats.empty": "Geen statistieken beschikbaar",
    "stats.goals": "Doelpunten",
    "leagues.group_second_div": "2e Divisies",
  },
  en: {
    "nav.home": "Home",
    "nav.matches": "Matches",
    "nav.predictions": "Predictions",
    "nav.standings": "Standings",
    "nav.live_now": "Live Now",
    "hero.badge": "AI-Powered Predictions",
    "hero.title_1": "Every kick.",
    "hero.title_2": "Every match.",
    "hero.title_3": "Realtime.",
    "hero.description": "Live scores, standings and tactical AI predictions for FIFA World Cup 2026, Champions League, Premier League, La Liga and Eredivisie — all in one place.",
    "hero.cta_matches": "View matches",
    "hero.cta_predictions": "AI Predictions",
    "hero.stat_live": "Live now",
    "hero.stat_upcoming": "Upcoming",
    "hero.stat_leagues": "Leagues",
    "hero.stat_predictions": "Predictions",
    "section.live_now": "Live Now",
    "section.live_subtitle": "{n} matches active",
    "section.upcoming": "Upcoming Matches",
    "section.upcoming_subtitle": "The next big duels",
    "section.view_all": "View all",
    "section.results": "Recent Results",
    "section.results_subtitle": "Last 24 hours",
    "section.topscorers": "Top Scorers",
    "section.stand_suffix": "Standings",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "All standings",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Club",
    "table.played": "P",
    "table.won": "W",
    "table.drawn": "D",
    "table.lost": "L",
    "table.gf": "GF",
    "table.ga": "GA",
    "table.points": "Pts",
    "table.form": "Form",
    "standings.title": "Standings",
    "standings.subtitle": "Live league rankings",
    "standings.cl_spot": "CL Spot",
    "standings.eur_spot": "Europa Spot",
    "matches.title": "Matches",
    "matches.subtitle": "Filter by league and status",
    "filter.all": "All",
    "filter.live": "Live",
    "filter.upcoming": "Upcoming",
    "filter.finished": "Finished",
    "matches.loading": "Loading...",
    "matches.empty": "No matches found",
    "detail.back": "Back",
    "detail.ai_prediction": "AI Prediction",
    "detail.powered_by": "Powered by Claude Sonnet 4.6",
    "detail.generate_cta": "Generate prediction",
    "detail.generate_help": "Generate an AI analysis based on form, standings and historical data.",
    "detail.thinking": "AI is thinking...",
    "detail.regenerate": "Regenerate",
    "detail.home_wins": "{team} wins",
    "detail.draw": "Draw",
    "detail.away_wins": "{team} wins",
    "detail.predicted_score": "Predicted score",
    "detail.confidence": "Confidence",
    "detail.analysis": "Analysis",
    "detail.key_factors": "Key factors",
    "detail.full_time": "Full Time",
    "detail.stadium": "Stadium",
    "detail.competition": "Competition",
    "detail.success": "AI prediction generated",
    "detail.error": "Could not generate prediction",
    "detail.loading": "Loading...",
    "pred.title": "AI Predictions",
    "pred.subtitle": "Tactical analyses generated by Claude Sonnet 4.6, based on form, standings and data.",
    "pred.no_matches": "No upcoming matches",
    "pred.predicted": "Predicted",
    "pred.home": "Home",
    "pred.draw": "Draw",
    "pred.away": "Away",
    "pred.full_analysis": "Full analysis",
    "pred.generate": "Generate AI",
    "pred.generating": "AI thinking...",
    "pred.success": "Prediction ready",
    "pred.error": "Prediction failed",
    "footer.tagline": "Live matches, results, standings and AI-driven predictions for the world's biggest leagues.",
    "footer.leagues": "Leagues",
    "footer.data": "Data",
    "footer.data_1": "Live via ESPN public API",
    "footer.data_2": "AI predictions (Claude)",
    "footer.data_3": "Realtime ticker",
    "footer.copyright": "Built for football fans",
    "lang.label": "Language",
    "footer.privacy": "Privacy Policy",
    "cookie.message": "We use cookies for ads (Google AdSense) and anonymous analytics.",
    "cookie.learn_more": "Learn more",
    "cookie.accept": "Accept all",
    "cookie.reject": "Only essential",
    "privacy.title": "Privacy Policy",
    "privacy.last_updated": "Last updated",
    "privacy.s1.title": "Who we are",
    "privacy.s1.body": "{site} is a football predictions and live-scores platform. We collect minimal personal data.",
    "privacy.s2.title": "What data we collect",
    "privacy.s2.body": "We process the following data:",
    "privacy.s2.item1": "Anonymous visitor statistics (PostHog)",
    "privacy.s2.item2": "Cookies for ad personalization (Google AdSense)",
    "privacy.s2.item3": "Language preference stored in localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "This site uses Google AdSense to display ads. Google may use cookies to personalize ads. You can opt out of personalized advertising via:",
    "privacy.s4.title": "Third-party services",
    "privacy.s4.body": "We rely on the following third parties:",
    "privacy.s5.title": "Your rights (GDPR)",
    "privacy.s5.body": "You have the right to access, correct, delete and object to processing of your data.",
    "privacy.s6.title": "Contact",
    "privacy.s6.body": "Questions about privacy? Contact us at:",
    "search.open": "Search",
    "search.placeholder": "Search match, team, league...",
    "search.empty": "No results",
    "search.loading": "Searching...",
    "search.hint": "Tap to open match",
    "matches.search_placeholder": "Filter by team, league or venue",
    "search.clear": "Clear",
    "nav.teams": "Clubs",
    "teams.title": "Clubs",
    "teams.subtitle": "{n} clubs found",
    "teams.search_placeholder": "Search club, league or country...",
    "teams.empty": "No clubs found",
    "leagues.group_international": "International",
    "leagues.group_uefa_cups": "UEFA Cups",
    "leagues.group_top5": "Top 5 Europe",
    "leagues.group_europe_other": "Europe — Other",
    "leagues.group_cups": "Domestic Cups",
    "leagues.group_americas": "Americas",
    "leagues.group_asia": "Asia & Oceania",
    "stats.title": "Match Stats",
    "stats.loading": "Loading stats...",
    "stats.empty": "No stats available",
    "stats.goals": "Goals",
    "leagues.group_second_div": "Second Divisions",
  },
  es: {
    "nav.home": "Inicio",
    "nav.matches": "Partidos",
    "nav.predictions": "Predicciones",
    "nav.standings": "Clasificación",
    "nav.live_now": "En Vivo",
    "hero.badge": "Predicciones con IA",
    "hero.title_1": "Cada chut.",
    "hero.title_2": "Cada partido.",
    "hero.title_3": "En tiempo real.",
    "hero.description": "Resultados en vivo, clasificaciones y predicciones tácticas con IA para el Mundial FIFA 2026, Champions League, Premier League, La Liga y Eredivisie — todo en un solo lugar.",
    "hero.cta_matches": "Ver partidos",
    "hero.cta_predictions": "Predicciones IA",
    "hero.stat_live": "En vivo",
    "hero.stat_upcoming": "Próximos",
    "hero.stat_leagues": "Ligas",
    "hero.stat_predictions": "Predicciones",
    "section.live_now": "En Vivo",
    "section.live_subtitle": "{n} partidos activos",
    "section.upcoming": "Próximos Partidos",
    "section.upcoming_subtitle": "Los siguientes grandes duelos",
    "section.view_all": "Ver todos",
    "section.results": "Resultados Recientes",
    "section.results_subtitle": "Últimas 24 horas",
    "section.topscorers": "Goleadores",
    "section.stand_suffix": "Clasificación",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Todas las clasificaciones",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Club",
    "table.played": "PJ",
    "table.won": "G",
    "table.drawn": "E",
    "table.lost": "P",
    "table.gf": "GF",
    "table.ga": "GC",
    "table.points": "Pts",
    "table.form": "Forma",
    "standings.title": "Clasificación",
    "standings.subtitle": "Rankings de ligas en vivo",
    "standings.cl_spot": "Plaza CL",
    "standings.eur_spot": "Plaza Europa",
    "matches.title": "Partidos",
    "matches.subtitle": "Filtra por liga y estado",
    "filter.all": "Todos",
    "filter.live": "En vivo",
    "filter.upcoming": "Próximos",
    "filter.finished": "Finalizados",
    "matches.loading": "Cargando...",
    "matches.empty": "No se encontraron partidos",
    "detail.back": "Volver",
    "detail.ai_prediction": "Predicción IA",
    "detail.powered_by": "Impulsado por Claude Sonnet 4.6",
    "detail.generate_cta": "Generar predicción",
    "detail.generate_help": "Genera un análisis con IA basado en forma, clasificación e historial.",
    "detail.thinking": "La IA está pensando...",
    "detail.regenerate": "Regenerar",
    "detail.home_wins": "{team} gana",
    "detail.draw": "Empate",
    "detail.away_wins": "{team} gana",
    "detail.predicted_score": "Marcador previsto",
    "detail.confidence": "Confianza",
    "detail.analysis": "Análisis",
    "detail.key_factors": "Factores clave",
    "detail.full_time": "Final",
    "detail.stadium": "Estadio",
    "detail.competition": "Competición",
    "detail.success": "Predicción IA generada",
    "detail.error": "No se pudo generar la predicción",
    "detail.loading": "Cargando...",
    "pred.title": "Predicciones IA",
    "pred.subtitle": "Análisis tácticos generados por Claude Sonnet 4.6, basados en forma, clasificación y datos.",
    "pred.no_matches": "No hay próximos partidos",
    "pred.predicted": "Previsto",
    "pred.home": "Local",
    "pred.draw": "Empate",
    "pred.away": "Visitante",
    "pred.full_analysis": "Análisis completo",
    "pred.generate": "Generar IA",
    "pred.generating": "IA pensando...",
    "pred.success": "Predicción lista",
    "pred.error": "Predicción fallida",
    "footer.tagline": "Partidos en vivo, resultados, clasificaciones y predicciones con IA para las ligas más grandes del mundo.",
    "footer.leagues": "Ligas",
    "footer.data": "Datos",
    "footer.data_1": "En vivo vía API pública de ESPN",
    "footer.data_2": "Predicciones IA (Claude)",
    "footer.data_3": "Ticker en tiempo real",
    "footer.copyright": "Hecho para los amantes del fútbol",
    "lang.label": "Idioma",
    "footer.privacy": "Política de Privacidad",
    "cookie.message": "Usamos cookies para anuncios (Google AdSense) y analíticas anónimas.",
    "cookie.learn_more": "Más información",
    "cookie.accept": "Aceptar todo",
    "cookie.reject": "Solo esenciales",
    "privacy.title": "Política de Privacidad",
    "privacy.last_updated": "Última actualización",
    "privacy.s1.title": "Quiénes somos",
    "privacy.s1.body": "{site} es una plataforma de predicciones y resultados de fútbol en vivo. Recopilamos datos personales mínimos.",
    "privacy.s2.title": "Qué datos recopilamos",
    "privacy.s2.body": "Procesamos los siguientes datos:",
    "privacy.s2.item1": "Estadísticas anónimas de visitantes (PostHog)",
    "privacy.s2.item2": "Cookies para personalización de anuncios (Google AdSense)",
    "privacy.s2.item3": "Preferencia de idioma guardada en localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Este sitio usa Google AdSense para mostrar anuncios. Google puede usar cookies para personalizar anuncios. Puedes desactivar la publicidad personalizada en:",
    "privacy.s4.title": "Servicios externos",
    "privacy.s4.body": "Confiamos en los siguientes terceros:",
    "privacy.s5.title": "Tus derechos (GDPR)",
    "privacy.s5.body": "Tienes derecho a acceder, corregir, eliminar y oponerte al tratamiento de tus datos.",
    "privacy.s6.title": "Contacto",
    "privacy.s6.body": "¿Preguntas sobre privacidad? Contáctanos en:",
    "search.open": "Buscar",
    "search.placeholder": "Busca partido, equipo, liga...",
    "search.empty": "Sin resultados",
    "search.loading": "Buscando...",
    "search.hint": "Toca para abrir el partido",
    "matches.search_placeholder": "Filtrar por equipo, liga o estadio",
    "search.clear": "Borrar",
    "nav.teams": "Clubes",
    "teams.title": "Clubes",
    "teams.subtitle": "{n} clubes encontrados",
    "teams.search_placeholder": "Busca club, liga o país...",
    "teams.empty": "No se encontraron clubes",
    "leagues.group_international": "Internacional",
    "leagues.group_uefa_cups": "Copas UEFA",
    "leagues.group_top5": "Top 5 Europa",
    "leagues.group_europe_other": "Europa — Otras",
    "leagues.group_cups": "Copas Nacionales",
    "leagues.group_americas": "América",
    "leagues.group_asia": "Asia y Oceanía",
    "stats.title": "Estadísticas del Partido",
    "stats.loading": "Cargando estadísticas...",
    "stats.empty": "Sin estadísticas disponibles",
    "stats.goals": "Goles",
    "leagues.group_second_div": "Segundas Divisiones",
  },
  fr: {
    "nav.home": "Accueil",
    "nav.matches": "Matchs",
    "nav.predictions": "Pronostics",
    "nav.standings": "Classement",
    "nav.live_now": "En Direct",
    "hero.badge": "Pronostics par IA",
    "hero.title_1": "Chaque frappe.",
    "hero.title_2": "Chaque match.",
    "hero.title_3": "En direct.",
    "hero.description": "Scores en direct, classements et pronostics tactiques par IA pour la Coupe du Monde FIFA 2026, Ligue des Champions, Premier League, La Liga et Eredivisie — tout au même endroit.",
    "hero.cta_matches": "Voir les matchs",
    "hero.cta_predictions": "Pronostics IA",
    "hero.stat_live": "En direct",
    "hero.stat_upcoming": "À venir",
    "hero.stat_leagues": "Ligues",
    "hero.stat_predictions": "Pronostics",
    "section.live_now": "En Direct",
    "section.live_subtitle": "{n} matchs en cours",
    "section.upcoming": "Matchs à Venir",
    "section.upcoming_subtitle": "Les prochains grands duels",
    "section.view_all": "Voir tout",
    "section.results": "Résultats Récents",
    "section.results_subtitle": "Dernières 24 heures",
    "section.topscorers": "Meilleurs Buteurs",
    "section.stand_suffix": "Classement",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Tous les classements",
    "match.ft": "TF",
    "match.vs": "VS",
    "table.club": "Club",
    "table.played": "J",
    "table.won": "G",
    "table.drawn": "N",
    "table.lost": "P",
    "table.gf": "BP",
    "table.ga": "BC",
    "table.points": "Pts",
    "table.form": "Forme",
    "standings.title": "Classement",
    "standings.subtitle": "Classements de ligues en direct",
    "standings.cl_spot": "Place LdC",
    "standings.eur_spot": "Place Europa",
    "matches.title": "Matchs",
    "matches.subtitle": "Filtrer par ligue et statut",
    "filter.all": "Tous",
    "filter.live": "Direct",
    "filter.upcoming": "À venir",
    "filter.finished": "Terminés",
    "matches.loading": "Chargement...",
    "matches.empty": "Aucun match trouvé",
    "detail.back": "Retour",
    "detail.ai_prediction": "Pronostic IA",
    "detail.powered_by": "Propulsé par Claude Sonnet 4.6",
    "detail.generate_cta": "Générer un pronostic",
    "detail.generate_help": "Générez une analyse IA basée sur la forme, le classement et l'historique.",
    "detail.thinking": "L'IA réfléchit...",
    "detail.regenerate": "Régénérer",
    "detail.home_wins": "{team} gagne",
    "detail.draw": "Match nul",
    "detail.away_wins": "{team} gagne",
    "detail.predicted_score": "Score prévu",
    "detail.confidence": "Confiance",
    "detail.analysis": "Analyse",
    "detail.key_factors": "Facteurs clés",
    "detail.full_time": "Temps Plein",
    "detail.stadium": "Stade",
    "detail.competition": "Compétition",
    "detail.success": "Pronostic IA généré",
    "detail.error": "Impossible de générer le pronostic",
    "detail.loading": "Chargement...",
    "pred.title": "Pronostics IA",
    "pred.subtitle": "Analyses tactiques générées par Claude Sonnet 4.6, basées sur la forme, le classement et les données.",
    "pred.no_matches": "Aucun match à venir",
    "pred.predicted": "Prévu",
    "pred.home": "Dom.",
    "pred.draw": "Nul",
    "pred.away": "Ext.",
    "pred.full_analysis": "Analyse complète",
    "pred.generate": "Générer IA",
    "pred.generating": "IA réfléchit...",
    "pred.success": "Pronostic prêt",
    "pred.error": "Pronostic échoué",
    "footer.tagline": "Matchs en direct, résultats, classements et pronostics IA pour les plus grandes ligues du monde.",
    "footer.leagues": "Ligues",
    "footer.data": "Données",
    "footer.data_1": "En direct via l'API publique ESPN",
    "footer.data_2": "Pronostics IA (Claude)",
    "footer.data_3": "Ticker en temps réel",
    "footer.copyright": "Conçu pour les fans de football",
    "lang.label": "Langue",
    "footer.privacy": "Politique de Confidentialité",
    "cookie.message": "Nous utilisons des cookies pour les publicités (Google AdSense) et l'analyse anonyme.",
    "cookie.learn_more": "En savoir plus",
    "cookie.accept": "Tout accepter",
    "cookie.reject": "Essentiels uniquement",
    "privacy.title": "Politique de Confidentialité",
    "privacy.last_updated": "Dernière mise à jour",
    "privacy.s1.title": "Qui sommes-nous",
    "privacy.s1.body": "{site} est une plateforme de pronostics et scores en direct. Nous collectons un minimum de données personnelles.",
    "privacy.s2.title": "Quelles données nous collectons",
    "privacy.s2.body": "Nous traitons les données suivantes :",
    "privacy.s2.item1": "Statistiques anonymes de visite (PostHog)",
    "privacy.s2.item2": "Cookies pour la personnalisation des publicités (Google AdSense)",
    "privacy.s2.item3": "Préférence de langue stockée dans localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Ce site utilise Google AdSense pour afficher des publicités. Google peut utiliser des cookies pour personnaliser les publicités. Vous pouvez désactiver la publicité personnalisée via :",
    "privacy.s4.title": "Services tiers",
    "privacy.s4.body": "Nous nous appuyons sur les services tiers suivants :",
    "privacy.s5.title": "Vos droits (RGPD)",
    "privacy.s5.body": "Vous avez le droit d'accéder, corriger, supprimer et vous opposer au traitement de vos données.",
    "privacy.s6.title": "Contact",
    "privacy.s6.body": "Des questions sur la confidentialité ? Contactez-nous à :",
    "search.open": "Rechercher",
    "search.placeholder": "Rechercher match, équipe, ligue...",
    "search.empty": "Aucun résultat",
    "search.loading": "Recherche...",
    "search.hint": "Touchez pour ouvrir le match",
    "matches.search_placeholder": "Filtrer par équipe, ligue ou stade",
    "search.clear": "Effacer",
    "nav.teams": "Clubs",
    "teams.title": "Clubs",
    "teams.subtitle": "{n} clubs trouvés",
    "teams.search_placeholder": "Rechercher club, ligue ou pays...",
    "teams.empty": "Aucun club trouvé",
    "leagues.group_international": "International",
    "leagues.group_uefa_cups": "Coupes UEFA",
    "leagues.group_top5": "Top 5 Europe",
    "leagues.group_europe_other": "Europe — Autres",
    "leagues.group_cups": "Coupes Nationales",
    "leagues.group_americas": "Amériques",
    "leagues.group_asia": "Asie et Océanie",
    "stats.title": "Statistiques du Match",
    "stats.loading": "Chargement des stats...",
    "stats.empty": "Aucune statistique disponible",
    "stats.goals": "Buts",
    "leagues.group_second_div": "Deuxièmes Divisions",
  },
  de: {
    "nav.home": "Start",
    "nav.matches": "Spiele",
    "nav.predictions": "Vorhersagen",
    "nav.standings": "Tabelle",
    "nav.live_now": "Live",
    "hero.badge": "KI-gestützte Vorhersagen",
    "hero.title_1": "Jeder Schuss.",
    "hero.title_2": "Jedes Spiel.",
    "hero.title_3": "In Echtzeit.",
    "hero.description": "Live-Ergebnisse, Tabellen und taktische KI-Vorhersagen für die FIFA WM 2026, Champions League, Premier League, La Liga und Eredivisie — alles an einem Ort.",
    "hero.cta_matches": "Spiele ansehen",
    "hero.cta_predictions": "KI-Vorhersagen",
    "hero.stat_live": "Live jetzt",
    "hero.stat_upcoming": "Kommend",
    "hero.stat_leagues": "Ligen",
    "hero.stat_predictions": "Vorhersagen",
    "section.live_now": "Live Jetzt",
    "section.live_subtitle": "{n} Spiele aktiv",
    "section.upcoming": "Kommende Spiele",
    "section.upcoming_subtitle": "Die nächsten großen Duelle",
    "section.view_all": "Alle ansehen",
    "section.results": "Aktuelle Ergebnisse",
    "section.results_subtitle": "Letzte 24 Stunden",
    "section.topscorers": "Top-Torjäger",
    "section.stand_suffix": "Tabelle",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Alle Tabellen",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Verein",
    "table.played": "Sp",
    "table.won": "S",
    "table.drawn": "U",
    "table.lost": "N",
    "table.gf": "Tore",
    "table.ga": "Geg",
    "table.points": "Pkt",
    "table.form": "Form",
    "standings.title": "Tabelle",
    "standings.subtitle": "Live Liga-Tabellen",
    "standings.cl_spot": "CL-Platz",
    "standings.eur_spot": "Europa-Platz",
    "matches.title": "Spiele",
    "matches.subtitle": "Nach Liga und Status filtern",
    "filter.all": "Alle",
    "filter.live": "Live",
    "filter.upcoming": "Kommend",
    "filter.finished": "Beendet",
    "matches.loading": "Lade...",
    "matches.empty": "Keine Spiele gefunden",
    "detail.back": "Zurück",
    "detail.ai_prediction": "KI-Vorhersage",
    "detail.powered_by": "Unterstützt von Claude Sonnet 4.6",
    "detail.generate_cta": "Vorhersage generieren",
    "detail.generate_help": "Generiere eine KI-Analyse basierend auf Form, Tabelle und Historie.",
    "detail.thinking": "KI denkt nach...",
    "detail.regenerate": "Neu generieren",
    "detail.home_wins": "{team} gewinnt",
    "detail.draw": "Unentschieden",
    "detail.away_wins": "{team} gewinnt",
    "detail.predicted_score": "Vorhergesagter Stand",
    "detail.confidence": "Vertrauen",
    "detail.analysis": "Analyse",
    "detail.key_factors": "Schlüsselfaktoren",
    "detail.full_time": "Abpfiff",
    "detail.stadium": "Stadion",
    "detail.competition": "Wettbewerb",
    "detail.success": "KI-Vorhersage generiert",
    "detail.error": "Vorhersage konnte nicht erstellt werden",
    "detail.loading": "Lade...",
    "pred.title": "KI-Vorhersagen",
    "pred.subtitle": "Taktische Analysen von Claude Sonnet 4.6, basierend auf Form, Tabelle und Daten.",
    "pred.no_matches": "Keine kommenden Spiele",
    "pred.predicted": "Vorhergesagt",
    "pred.home": "Heim",
    "pred.draw": "Unent.",
    "pred.away": "Auswärts",
    "pred.full_analysis": "Vollständige Analyse",
    "pred.generate": "KI generieren",
    "pred.generating": "KI denkt...",
    "pred.success": "Vorhersage bereit",
    "pred.error": "Vorhersage fehlgeschlagen",
    "footer.tagline": "Live-Spiele, Ergebnisse, Tabellen und KI-Vorhersagen für die größten Ligen der Welt.",
    "footer.leagues": "Ligen",
    "footer.data": "Daten",
    "footer.data_1": "Live über ESPN Public API",
    "footer.data_2": "KI-Vorhersagen (Claude)",
    "footer.data_3": "Echtzeit-Ticker",
    "footer.copyright": "Für Fußballfans gemacht",
    "lang.label": "Sprache",
    "footer.privacy": "Datenschutz",
    "cookie.message": "Wir verwenden Cookies für Werbung (Google AdSense) und anonyme Analysen.",
    "cookie.learn_more": "Mehr erfahren",
    "cookie.accept": "Alle akzeptieren",
    "cookie.reject": "Nur notwendige",
    "privacy.title": "Datenschutzerklärung",
    "privacy.last_updated": "Zuletzt aktualisiert",
    "privacy.s1.title": "Wer wir sind",
    "privacy.s1.body": "{site} ist eine Plattform für Fußballvorhersagen und Live-Ergebnisse. Wir erheben minimale personenbezogene Daten.",
    "privacy.s2.title": "Welche Daten wir erheben",
    "privacy.s2.body": "Wir verarbeiten folgende Daten:",
    "privacy.s2.item1": "Anonyme Besuchsstatistiken (PostHog)",
    "privacy.s2.item2": "Cookies zur Anzeigen-Personalisierung (Google AdSense)",
    "privacy.s2.item3": "Spracheinstellung im localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Diese Seite nutzt Google AdSense zur Anzeige von Werbung. Google kann Cookies zur Personalisierung verwenden. Personalisierte Werbung kannst du deaktivieren über:",
    "privacy.s4.title": "Drittanbieter",
    "privacy.s4.body": "Wir nutzen folgende Drittanbieter:",
    "privacy.s5.title": "Deine Rechte (DSGVO)",
    "privacy.s5.body": "Du hast das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch gegen die Verarbeitung deiner Daten.",
    "privacy.s6.title": "Kontakt",
    "privacy.s6.body": "Fragen zum Datenschutz? Kontaktiere uns unter:",
    "search.open": "Suchen",
    "search.placeholder": "Spiel, Verein, Liga suchen...",
    "search.empty": "Keine Ergebnisse",
    "search.loading": "Suche...",
    "search.hint": "Tippen um Spiel zu öffnen",
    "matches.search_placeholder": "Nach Verein, Liga oder Stadion filtern",
    "search.clear": "Löschen",
    "nav.teams": "Vereine",
    "teams.title": "Vereine",
    "teams.subtitle": "{n} Vereine gefunden",
    "teams.search_placeholder": "Verein, Liga oder Land suchen...",
    "teams.empty": "Keine Vereine gefunden",
    "leagues.group_international": "International",
    "leagues.group_uefa_cups": "UEFA-Wettbewerbe",
    "leagues.group_top5": "Top 5 Europa",
    "leagues.group_europe_other": "Europa — Sonstige",
    "leagues.group_cups": "Nationale Pokale",
    "leagues.group_americas": "Amerika",
    "leagues.group_asia": "Asien & Ozeanien",
    "stats.title": "Spielstatistiken",
    "stats.loading": "Statistiken werden geladen...",
    "stats.empty": "Keine Statistiken verfügbar",
    "stats.goals": "Tore",
    "leagues.group_second_div": "Zweite Ligen",
  },
  pt: {
    "nav.home": "Início",
    "nav.matches": "Jogos",
    "nav.predictions": "Previsões",
    "nav.standings": "Classificação",
    "nav.live_now": "Ao Vivo",
    "hero.badge": "Previsões com IA",
    "hero.title_1": "Cada chute.",
    "hero.title_2": "Cada jogo.",
    "hero.title_3": "Em tempo real.",
    "hero.description": "Resultados ao vivo, classificações e previsões táticas com IA para a Copa do Mundo FIFA 2026, Liga dos Campeões, Premier League, La Liga e Eredivisie — tudo num só lugar.",
    "hero.cta_matches": "Ver jogos",
    "hero.cta_predictions": "Previsões IA",
    "hero.stat_live": "Ao vivo",
    "hero.stat_upcoming": "Próximos",
    "hero.stat_leagues": "Ligas",
    "hero.stat_predictions": "Previsões",
    "section.live_now": "Ao Vivo",
    "section.live_subtitle": "{n} jogos ativos",
    "section.upcoming": "Próximos Jogos",
    "section.upcoming_subtitle": "Os próximos grandes duelos",
    "section.view_all": "Ver todos",
    "section.results": "Resultados Recentes",
    "section.results_subtitle": "Últimas 24 horas",
    "section.topscorers": "Artilheiros",
    "section.stand_suffix": "Classificação",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Todas as classificações",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Clube",
    "table.played": "J",
    "table.won": "V",
    "table.drawn": "E",
    "table.lost": "D",
    "table.gf": "GP",
    "table.ga": "GC",
    "table.points": "Pts",
    "table.form": "Forma",
    "standings.title": "Classificação",
    "standings.subtitle": "Rankings de ligas ao vivo",
    "standings.cl_spot": "Vaga CL",
    "standings.eur_spot": "Vaga Europa",
    "matches.title": "Jogos",
    "matches.subtitle": "Filtrar por liga e status",
    "filter.all": "Todos",
    "filter.live": "Ao vivo",
    "filter.upcoming": "Próximos",
    "filter.finished": "Terminados",
    "matches.loading": "Carregando...",
    "matches.empty": "Nenhum jogo encontrado",
    "detail.back": "Voltar",
    "detail.ai_prediction": "Previsão IA",
    "detail.powered_by": "Desenvolvido por Claude Sonnet 4.6",
    "detail.generate_cta": "Gerar previsão",
    "detail.generate_help": "Gere uma análise IA baseada em forma, classificação e dados históricos.",
    "detail.thinking": "IA pensando...",
    "detail.regenerate": "Regenerar",
    "detail.home_wins": "{team} vence",
    "detail.draw": "Empate",
    "detail.away_wins": "{team} vence",
    "detail.predicted_score": "Placar previsto",
    "detail.confidence": "Confiança",
    "detail.analysis": "Análise",
    "detail.key_factors": "Fatores-chave",
    "detail.full_time": "Final de Jogo",
    "detail.stadium": "Estádio",
    "detail.competition": "Competição",
    "detail.success": "Previsão IA gerada",
    "detail.error": "Não foi possível gerar a previsão",
    "detail.loading": "Carregando...",
    "pred.title": "Previsões IA",
    "pred.subtitle": "Análises táticas geradas por Claude Sonnet 4.6, baseadas em forma, classificação e dados.",
    "pred.no_matches": "Nenhum jogo próximo",
    "pred.predicted": "Previsto",
    "pred.home": "Casa",
    "pred.draw": "Empate",
    "pred.away": "Fora",
    "pred.full_analysis": "Análise completa",
    "pred.generate": "Gerar IA",
    "pred.generating": "IA pensando...",
    "pred.success": "Previsão pronta",
    "pred.error": "Previsão falhou",
    "footer.tagline": "Jogos ao vivo, resultados, classificações e previsões com IA para as maiores ligas do mundo.",
    "footer.leagues": "Ligas",
    "footer.data": "Dados",
    "footer.data_1": "Ao vivo via API pública da ESPN",
    "footer.data_2": "Previsões IA (Claude)",
    "footer.data_3": "Ticker em tempo real",
    "footer.copyright": "Feito para fãs de futebol",
    "lang.label": "Idioma",
    "footer.privacy": "Política de Privacidade",
    "cookie.message": "Usamos cookies para anúncios (Google AdSense) e análises anónimas.",
    "cookie.learn_more": "Saber mais",
    "cookie.accept": "Aceitar tudo",
    "cookie.reject": "Apenas essenciais",
    "privacy.title": "Política de Privacidade",
    "privacy.last_updated": "Atualizado em",
    "privacy.s1.title": "Quem somos",
    "privacy.s1.body": "{site} é uma plataforma de previsões e resultados de futebol ao vivo. Recolhemos dados pessoais mínimos.",
    "privacy.s2.title": "Que dados recolhemos",
    "privacy.s2.body": "Processamos os seguintes dados:",
    "privacy.s2.item1": "Estatísticas anónimas de visitantes (PostHog)",
    "privacy.s2.item2": "Cookies para personalização de anúncios (Google AdSense)",
    "privacy.s2.item3": "Preferência de idioma guardada no localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Este site usa Google AdSense para mostrar anúncios. O Google pode usar cookies para personalizar anúncios. Pode desativar a publicidade personalizada em:",
    "privacy.s4.title": "Serviços externos",
    "privacy.s4.body": "Recorremos aos seguintes terceiros:",
    "privacy.s5.title": "Os seus direitos (RGPD)",
    "privacy.s5.body": "Tem o direito de aceder, corrigir, eliminar e opor-se ao processamento dos seus dados.",
    "privacy.s6.title": "Contacto",
    "privacy.s6.body": "Questões sobre privacidade? Contacte-nos em:",
    "search.open": "Pesquisar",
    "search.placeholder": "Pesquisar jogo, equipa, liga...",
    "search.empty": "Sem resultados",
    "search.loading": "A pesquisar...",
    "search.hint": "Toque para abrir o jogo",
    "matches.search_placeholder": "Filtrar por equipa, liga ou estádio",
    "search.clear": "Limpar",
    "nav.teams": "Clubes",
    "teams.title": "Clubes",
    "teams.subtitle": "{n} clubes encontrados",
    "teams.search_placeholder": "Pesquisar clube, liga ou país...",
    "teams.empty": "Nenhum clube encontrado",
    "leagues.group_international": "Internacional",
    "leagues.group_uefa_cups": "Competições UEFA",
    "leagues.group_top5": "Top 5 Europa",
    "leagues.group_europe_other": "Europa — Outras",
    "leagues.group_cups": "Taças Nacionais",
    "leagues.group_americas": "Américas",
    "leagues.group_asia": "Ásia e Oceânia",
    "stats.title": "Estatísticas do Jogo",
    "stats.loading": "A carregar estatísticas...",
    "stats.empty": "Sem estatísticas disponíveis",
    "stats.goals": "Golos",
    "leagues.group_second_div": "Segundas Divisões",
  },
  it: {
    "nav.home": "Home",
    "nav.matches": "Partite",
    "nav.predictions": "Pronostici",
    "nav.standings": "Classifica",
    "nav.live_now": "In Diretta",
    "hero.badge": "Pronostici con IA",
    "hero.title_1": "Ogni tiro.",
    "hero.title_2": "Ogni partita.",
    "hero.title_3": "In tempo reale.",
    "hero.description": "Risultati live, classifiche e pronostici tattici con IA per la Coppa del Mondo FIFA 2026, Champions League, Premier League, La Liga ed Eredivisie — tutto in un unico posto.",
    "hero.cta_matches": "Vedi partite",
    "hero.cta_predictions": "Pronostici IA",
    "hero.stat_live": "In diretta",
    "hero.stat_upcoming": "In arrivo",
    "hero.stat_leagues": "Campionati",
    "hero.stat_predictions": "Pronostici",
    "section.live_now": "In Diretta",
    "section.live_subtitle": "{n} partite attive",
    "section.upcoming": "Prossime Partite",
    "section.upcoming_subtitle": "I prossimi grandi duelli",
    "section.view_all": "Vedi tutto",
    "section.results": "Risultati Recenti",
    "section.results_subtitle": "Ultime 24 ore",
    "section.topscorers": "Capocannonieri",
    "section.stand_suffix": "Classifica",
    "section.top_n": "Top {n}",
    "section.view_all_standings": "Tutte le classifiche",
    "match.ft": "FT",
    "match.vs": "VS",
    "table.club": "Club",
    "table.played": "G",
    "table.won": "V",
    "table.drawn": "N",
    "table.lost": "P",
    "table.gf": "GF",
    "table.ga": "GS",
    "table.points": "Pt",
    "table.form": "Forma",
    "standings.title": "Classifica",
    "standings.subtitle": "Classifiche dei campionati in diretta",
    "standings.cl_spot": "Posto CL",
    "standings.eur_spot": "Posto Europa",
    "matches.title": "Partite",
    "matches.subtitle": "Filtra per campionato e stato",
    "filter.all": "Tutte",
    "filter.live": "Live",
    "filter.upcoming": "In arrivo",
    "filter.finished": "Concluse",
    "matches.loading": "Caricamento...",
    "matches.empty": "Nessuna partita trovata",
    "detail.back": "Indietro",
    "detail.ai_prediction": "Pronostico IA",
    "detail.powered_by": "Powered by Claude Sonnet 4.6",
    "detail.generate_cta": "Genera pronostico",
    "detail.generate_help": "Genera un'analisi IA basata su forma, classifica e dati storici.",
    "detail.thinking": "L'IA sta pensando...",
    "detail.regenerate": "Rigenera",
    "detail.home_wins": "{team} vince",
    "detail.draw": "Pareggio",
    "detail.away_wins": "{team} vince",
    "detail.predicted_score": "Risultato previsto",
    "detail.confidence": "Affidabilità",
    "detail.analysis": "Analisi",
    "detail.key_factors": "Fattori chiave",
    "detail.full_time": "Fine Partita",
    "detail.stadium": "Stadio",
    "detail.competition": "Competizione",
    "detail.success": "Pronostico IA generato",
    "detail.error": "Impossibile generare il pronostico",
    "detail.loading": "Caricamento...",
    "pred.title": "Pronostici IA",
    "pred.subtitle": "Analisi tattiche generate da Claude Sonnet 4.6, basate su forma, classifica e dati.",
    "pred.no_matches": "Nessuna partita in arrivo",
    "pred.predicted": "Previsto",
    "pred.home": "Casa",
    "pred.draw": "Pareggio",
    "pred.away": "Trasferta",
    "pred.full_analysis": "Analisi completa",
    "pred.generate": "Genera IA",
    "pred.generating": "IA pensa...",
    "pred.success": "Pronostico pronto",
    "pred.error": "Pronostico fallito",
    "footer.tagline": "Partite live, risultati, classifiche e pronostici IA per i campionati più grandi del mondo.",
    "footer.leagues": "Campionati",
    "footer.data": "Dati",
    "footer.data_1": "Live via ESPN public API",
    "footer.data_2": "Pronostici IA (Claude)",
    "footer.data_3": "Ticker in tempo reale",
    "footer.copyright": "Fatto per i fan del calcio",
    "lang.label": "Lingua",
    "footer.privacy": "Privacy",
    "cookie.message": "Utilizziamo cookie per annunci (Google AdSense) e analisi anonime.",
    "cookie.learn_more": "Maggiori info",
    "cookie.accept": "Accetta tutto",
    "cookie.reject": "Solo essenziali",
    "privacy.title": "Informativa sulla Privacy",
    "privacy.last_updated": "Ultimo aggiornamento",
    "privacy.s1.title": "Chi siamo",
    "privacy.s1.body": "{site} è una piattaforma di pronostici e risultati di calcio in tempo reale. Raccogliamo dati personali minimi.",
    "privacy.s2.title": "Quali dati raccogliamo",
    "privacy.s2.body": "Trattiamo i seguenti dati:",
    "privacy.s2.item1": "Statistiche anonime di visita (PostHog)",
    "privacy.s2.item2": "Cookie per personalizzazione annunci (Google AdSense)",
    "privacy.s2.item3": "Preferenza di lingua salvata in localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "Questo sito utilizza Google AdSense per mostrare annunci. Google può utilizzare cookie per personalizzare gli annunci. Puoi disattivare la pubblicità personalizzata su:",
    "privacy.s4.title": "Servizi terzi",
    "privacy.s4.body": "Ci affidiamo ai seguenti servizi terzi:",
    "privacy.s5.title": "I tuoi diritti (GDPR)",
    "privacy.s5.body": "Hai il diritto di accedere, correggere, cancellare e opporti al trattamento dei tuoi dati.",
    "privacy.s6.title": "Contatti",
    "privacy.s6.body": "Domande sulla privacy? Contattaci a:",
    "search.open": "Cerca",
    "search.placeholder": "Cerca partita, squadra, lega...",
    "search.empty": "Nessun risultato",
    "search.loading": "Ricerca...",
    "search.hint": "Tocca per aprire la partita",
    "matches.search_placeholder": "Filtra per squadra, lega o stadio",
    "search.clear": "Cancella",
    "nav.teams": "Squadre",
    "teams.title": "Squadre",
    "teams.subtitle": "{n} squadre trovate",
    "teams.search_placeholder": "Cerca squadra, lega o paese...",
    "teams.empty": "Nessuna squadra trovata",
    "leagues.group_international": "Internazionali",
    "leagues.group_uefa_cups": "Coppe UEFA",
    "leagues.group_top5": "Top 5 Europa",
    "leagues.group_europe_other": "Europa — Altre",
    "leagues.group_cups": "Coppe Nazionali",
    "leagues.group_americas": "Americhe",
    "leagues.group_asia": "Asia e Oceania",
    "stats.title": "Statistiche Partita",
    "stats.loading": "Caricamento statistiche...",
    "stats.empty": "Nessuna statistica disponibile",
    "stats.goals": "Gol",
    "leagues.group_second_div": "Seconde Divisioni",
  },
  ar: {
    "nav.home": "الرئيسية",
    "nav.matches": "المباريات",
    "nav.predictions": "التوقعات",
    "nav.standings": "الترتيب",
    "nav.live_now": "مباشر الآن",
    "hero.badge": "توقعات مدعومة بالذكاء الاصطناعي",
    "hero.title_1": "كل ركلة.",
    "hero.title_2": "كل مباراة.",
    "hero.title_3": "مباشرة.",
    "hero.description": "نتائج مباشرة، ترتيبات وتوقعات تكتيكية بالذكاء الاصطناعي لكأس العالم 2026، دوري أبطال أوروبا، الدوري الإنجليزي، الليغا والدوري الهولندي — كل ذلك في مكان واحد.",
    "hero.cta_matches": "عرض المباريات",
    "hero.cta_predictions": "توقعات الذكاء الاصطناعي",
    "hero.stat_live": "مباشر",
    "hero.stat_upcoming": "قادمة",
    "hero.stat_leagues": "البطولات",
    "hero.stat_predictions": "توقعات",
    "section.live_now": "مباشر الآن",
    "section.live_subtitle": "{n} مباريات نشطة",
    "section.upcoming": "المباريات القادمة",
    "section.upcoming_subtitle": "المواجهات الكبرى القادمة",
    "section.view_all": "عرض الكل",
    "section.results": "النتائج الأخيرة",
    "section.results_subtitle": "آخر 24 ساعة",
    "section.topscorers": "الهدافون",
    "section.stand_suffix": "الترتيب",
    "section.top_n": "أفضل {n}",
    "section.view_all_standings": "كل الترتيبات",
    "match.ft": "ن.م",
    "match.vs": "ضد",
    "table.club": "النادي",
    "table.played": "لعب",
    "table.won": "فوز",
    "table.drawn": "تعادل",
    "table.lost": "خسارة",
    "table.gf": "له",
    "table.ga": "عليه",
    "table.points": "نقاط",
    "table.form": "الشكل",
    "standings.title": "الترتيب",
    "standings.subtitle": "ترتيبات الدوريات المباشرة",
    "standings.cl_spot": "مقعد دوري الأبطال",
    "standings.eur_spot": "مقعد أوروبي",
    "matches.title": "المباريات",
    "matches.subtitle": "صفِّ حسب البطولة والحالة",
    "filter.all": "الكل",
    "filter.live": "مباشر",
    "filter.upcoming": "قادمة",
    "filter.finished": "منتهية",
    "matches.loading": "جار التحميل...",
    "matches.empty": "لا توجد مباريات",
    "detail.back": "رجوع",
    "detail.ai_prediction": "توقع الذكاء الاصطناعي",
    "detail.powered_by": "مدعوم بواسطة Claude Sonnet 4.6",
    "detail.generate_cta": "إنشاء توقع",
    "detail.generate_help": "أنشئ تحليلاً بالذكاء الاصطناعي بناءً على الفورمة والترتيب والبيانات التاريخية.",
    "detail.thinking": "الذكاء الاصطناعي يفكر...",
    "detail.regenerate": "إعادة التوليد",
    "detail.home_wins": "{team} يفوز",
    "detail.draw": "تعادل",
    "detail.away_wins": "{team} يفوز",
    "detail.predicted_score": "النتيجة المتوقعة",
    "detail.confidence": "الثقة",
    "detail.analysis": "التحليل",
    "detail.key_factors": "العوامل الرئيسية",
    "detail.full_time": "نهاية المباراة",
    "detail.stadium": "الملعب",
    "detail.competition": "البطولة",
    "detail.success": "تم إنشاء توقع الذكاء الاصطناعي",
    "detail.error": "تعذر إنشاء التوقع",
    "detail.loading": "جار التحميل...",
    "pred.title": "توقعات الذكاء الاصطناعي",
    "pred.subtitle": "تحليلات تكتيكية ينشئها Claude Sonnet 4.6 بناءً على الفورمة والترتيب والبيانات.",
    "pred.no_matches": "لا توجد مباريات قادمة",
    "pred.predicted": "متوقع",
    "pred.home": "ديار",
    "pred.draw": "تعادل",
    "pred.away": "خارج",
    "pred.full_analysis": "التحليل الكامل",
    "pred.generate": "إنشاء بالذكاء الاصطناعي",
    "pred.generating": "الذكاء الاصطناعي يفكر...",
    "pred.success": "التوقع جاهز",
    "pred.error": "فشل التوقع",
    "footer.tagline": "مباريات مباشرة، نتائج، ترتيبات وتوقعات بالذكاء الاصطناعي لأكبر بطولات العالم.",
    "footer.leagues": "البطولات",
    "footer.data": "البيانات",
    "footer.data_1": "مباشر عبر واجهة ESPN العامة",
    "footer.data_2": "توقعات الذكاء الاصطناعي (Claude)",
    "footer.data_3": "شريط مباشر",
    "footer.copyright": "صُنع لعشاق كرة القدم",
    "lang.label": "اللغة",
    "footer.privacy": "سياسة الخصوصية",
    "cookie.message": "نستخدم ملفات تعريف الارتباط للإعلانات (Google AdSense) والتحليلات المجهولة.",
    "cookie.learn_more": "اعرف المزيد",
    "cookie.accept": "قبول الكل",
    "cookie.reject": "الأساسية فقط",
    "privacy.title": "سياسة الخصوصية",
    "privacy.last_updated": "آخر تحديث",
    "privacy.s1.title": "من نحن",
    "privacy.s1.body": "{site} منصة للتنبؤات الكروية والنتائج المباشرة. نجمع الحد الأدنى من البيانات الشخصية.",
    "privacy.s2.title": "البيانات التي نجمعها",
    "privacy.s2.body": "نعالج البيانات التالية:",
    "privacy.s2.item1": "إحصاءات الزوار المجهولة (PostHog)",
    "privacy.s2.item2": "ملفات تعريف الارتباط لتخصيص الإعلانات (Google AdSense)",
    "privacy.s2.item3": "تفضيلات اللغة المحفوظة في localStorage",
    "privacy.s3.title": "Google AdSense",
    "privacy.s3.body": "يستخدم هذا الموقع Google AdSense لعرض الإعلانات. يمكنك إيقاف الإعلانات المخصصة عبر:",
    "privacy.s4.title": "خدمات خارجية",
    "privacy.s4.body": "نعتمد على الأطراف الخارجية التالية:",
    "privacy.s5.title": "حقوقك (GDPR)",
    "privacy.s5.body": "يحق لك الوصول إلى بياناتك وتصحيحها وحذفها.",
    "privacy.s6.title": "اتصل بنا",
    "privacy.s6.body": "أسئلة حول الخصوصية؟ تواصل معنا على:",
    "search.open": "بحث",
    "search.placeholder": "ابحث عن مباراة، فريق، بطولة...",
    "search.empty": "لا توجد نتائج",
    "search.loading": "جار البحث...",
    "search.hint": "اضغط لفتح المباراة",
    "matches.search_placeholder": "تصفية حسب الفريق أو البطولة أو الملعب",
    "search.clear": "مسح",
    "nav.teams": "الأندية",
    "teams.title": "الأندية",
    "teams.subtitle": "{n} أندية موجودة",
    "teams.search_placeholder": "ابحث عن نادٍ، بطولة أو بلد...",
    "teams.empty": "لا توجد أندية",
    "leagues.group_international": "دولي",
    "leagues.group_uefa_cups": "كؤوس اليويفا",
    "leagues.group_top5": "أكبر 5 دوريات أوروبية",
    "leagues.group_europe_other": "أوروبا — أخرى",
    "leagues.group_cups": "كؤوس محلية",
    "leagues.group_americas": "الأمريكتان",
    "leagues.group_asia": "آسيا وأوقيانوسيا",
    "stats.title": "إحصائيات المباراة",
    "stats.loading": "جار تحميل الإحصائيات...",
    "stats.empty": "لا توجد إحصائيات",
    "stats.goals": "الأهداف",
    "leagues.group_second_div": "الدرجة الثانية",
  },
};
